import './App.css';
import Home from './pages/home';
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Blog from './pages/blog';
import WallOfFame from './pages/wallOfFame';
import Navbar from '../src/components/common/navbar';
import Careers from '../src/pages/Careers';
import Team from '../src/pages/Team';
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} exact />
          <Route path="/blog/" element={<Blog />} />
          <Route path="/fame/" element={<WallOfFame />} />
          <Route path="/only-nav" element={<Navbar />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/team" element={<Team />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
